import { createEnv } from '@t3-oss/env-core';
import { z } from 'zod';

export const env = createEnv({
  clientPrefix: 'VITE_',
  client: {
    VITE_SERVER_URL: z.string().url(),
    VITE_UPLOADTHING_APP_ID: z.string().min(1),
    VITE_GLITCHTIP_DSN: z.string().optional(),
    VITE_GLITCHTIP_ENVIRONMENT: z.string().optional(),
  },
  runtimeEnv: import.meta.env,
  emptyStringAsUndefined: true,
});
